import { Box, DialogTitle, Typography } from '@mui/material';

import { DialogCloseButton } from '../';

type Props = {
  title: string;
  onClose: () => void;
};

export const DialogHeader = ({ onClose, title }: Props) => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        borderBottom: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        justifyContent: 'space-between',
        pb: 2,
      }}
    >
      <DialogTitle>
        <Typography variant="h6">{title}</Typography>
      </DialogTitle>
      <DialogCloseButton onClick={onClose} />
    </Box>
  );
};

DialogHeader.displayName = 'DialogHeader';
